import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import {
    Chip,
    Grid,
    IconButton,
    Paper,
    Tooltip,
    Typography,
} from '@mui/material'
import { GroupServiceSetting, ServicePrices } from '@types'
import { capitalize, copyValue } from '@utils'
import { DateTime } from 'luxon'
import { useMemo } from 'react'

interface Props {
    serviceSetting: GroupServiceSetting
    service: ServicePrices
}

export default function GroupSettingPane({
    serviceSetting,
    service,
}: Props): JSX.Element {
    const fromDate = useMemo(
        () =>
            DateTime.fromJSDate(serviceSetting.setting.from_date).toFormat(
                'DD HH:mm:ss'
            ),
        [serviceSetting]
    )
    const toDate = useMemo(() => {
        if (serviceSetting.setting.to_date) {
            return DateTime.fromJSDate(serviceSetting.setting.to_date).toFormat(
                'DD HH:mm:ss'
            )
        }
        return 'N/A'
    }, [serviceSetting])

    return (
        <Paper sx={{ height: '100%' }}>
            <Typography variant="h3">
                Setting
                <Chip
                    size="small"
                    color={
                        serviceSetting.type === 'allowed' ? 'success' : 'error'
                    }
                    sx={{ mx: '1em' }}
                    label={capitalize(serviceSetting.type)}
                />
            </Typography>
            <Grid container spacing={1}>
                <Grid item xs={3}>
                    <Typography variant="body1">Setting ID:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="subtitle1">
                        {serviceSetting.setting.id}
                        <Tooltip title="Copy Setting ID">
                            <IconButton
                                size="small"
                                onClick={copyValue(serviceSetting.setting.id)}
                            >
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body1">Service ID:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="subtitle1">
                        {service.id}
                        <Tooltip title="Copy Service ID">
                            <IconButton
                                size="small"
                                onClick={copyValue(service.id)}
                            >
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body1">Turnaround Time:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="body1">
                        {service.turnaround_time}hrs
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body1">
                        Unit Cost ({service.currency}):
                    </Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="body1">{service.unit_cost}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body1">Start Date:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="body1">{fromDate}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="body1">End Date:</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography variant="body1">{toDate}</Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}
